<template>
  <basic-container>
    <avue-crud :option="option"
               v-if="reWrite"
               :table-loading="loading"
               :data="data"
               :page.sync="page"
               :permission="permissionList"
               :before-open="beforeOpen"
               v-model="form"
               ref="crud"
               @row-update="rowUpdate"
               @row-save="rowSave"
               @row-del="rowDel"
               @search-change="searchChange"
               @search-reset="searchReset"
               @selection-change="selectionChange"
               @current-change="currentChange"
               @size-change="sizeChange"
               @refresh-change="onLoad"
               @on-load="onLoad">
      <template slot="menuLeft">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-plus"
                   v-if="permission.cartempcarfeerule_add"
                   @click="beforeOpen('add')">新增
        </el-button>
        <el-button type="danger"
                   size="small"
                   icon="el-icon-top"
                   plain
                   v-if="permission.cartempcarfeerule_sync"
                   @click="handleSync">同步下发
        </el-button>
      </template>
      <template slot="menu" slot-scope="scope">
        <el-button type="text"
                size="small"
                icon="el-icon-edit"
                v-if="permission.cartempcarfeerule_edit"
                @click="beforeOpen(scope.row)">编辑
        </el-button>
        <el-button type="text"
                   size="small"
                   icon="el-icon-edit"
                   v-if="permissionList.addBtn"
                   @click="copyFeeRule(scope.row)">复制
        </el-button>
      </template>
    </avue-crud>
    <el-dialog
      id="tempcar-fee-rule"
      :title="operateName"
      :visible.sync="showOperateDialog"
      :modal-append-to-body="false"
      width="70%"
      @close="closeDialog"
    >
      <el-row v-if="showOperateDialog">
        <el-col :span="18">
          <basic-container>
            <el-form ref="operateForm" :model="primaryForm" label-width="120px" margin-top="0">
              <el-row>
                <el-col :span="24"><strong style="font-size: 16px">临停收费规则</strong></el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item label="车场名称" prop="parkingLotId"
                                :rules="[{ required: true, message: '请选择车场名称', trigger: 'change' },]">
                    <el-select @change="parkChangeEvent" v-model="primaryForm.parkingLotId" style="width: 100%" :disabled="editDisable">
                      <el-option style="padding-left: 10px"
                                 v-for="item in spaceList"
                                 :key="item.id"
                                 :label="item.title"
                                 :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">

                  <el-form-item label="车场区域" prop="carParkSpaceAreaId"
                                :rules="[{ required: true, message: '请选择车场名称', trigger: 'change' },]">
                    <avue-input-tree :props="defaultProps"
                                     :check-strictly="true"
                                     v-model="primaryForm.carParkSpaceAreaId"
                                     placeholder="请选择车场名称"
                                     type="tree"
                                     :dic="spaceAreaList"
                    >

                    </avue-input-tree>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="规则名称"
                                prop="ruleName"
                                :rules="[{ required: true, message: '请输入规则名称', trigger: 'blur' },
                                {max:50, message: '请输入1-50位字符', trigger: 'blur' }]">
                    <el-input
                      v-model="primaryForm.ruleName"  :disabled="editDisable"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item label="规则编号"
                                prop="ruleCode"
                                :rules="[{ required: true, message: '请输入规则编号', trigger: 'blur' },
                                { min:3,max:12, message: '请输入3-12位的字符', trigger: 'blur' }]">
                    <el-input
                      v-model="primaryForm.ruleCode"  :disabled="editDisable"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="车辆类别"
                                prop="vehicleType"
                                :rules="[{ required: true, message: '请选择车辆类型', trigger: 'change' }]">
                    <el-select v-model="primaryForm.vehicleType" style="width: 100%">
                      <el-option
                        v-for="item in vehicleTypeList"
                        :key="item.dictKey"
                        :label="item.dictValue"
                        :value="item.dictKey"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="车主类型"
                                prop="driverType"
                                :rules="[{ required: true, message: '请选择车主类型', trigger: 'change' }]">
                    <el-select v-model="primaryForm.driverType" style="width: 100%">
                      <el-option
                        v-for="item in driverTypeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item label="循环计费方式"
                                prop="carFeeType"
                                :rules="[{ required: true, message: '请选择收费方式', trigger: 'blur' }]">
                    <el-select v-model="primaryForm.carFeeType" @change="onChangFeeType" style="width: 100%" :disabled="editDisable">
                      <el-option
                        v-for="item in carFeeTypeList"
                        :key="item.dictKey"
                        :label="item.dictValue"
                        :value="item.dictKey"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="总收费限额(元)"
                                prop="totalAmountLimit"
                                :rules="moneyRules">
                    <el-input type="number" v-model="primaryForm.totalAmountLimit" style="width: 100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="免费时长(分钟)"
                                prop="freeTime"
                                :rules="freeTimeRules">
                    <el-input type="number" v-model="primaryForm.freeTime" style="width: 100%"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item label="包含免费时长" prop="includeFreeTime">
                    <el-switch
                      style="display: block"
                      v-model="includeFreeTime"
                      :active-value="switchValue.yes"
                      :inactive-value="switchValue.no"
                    ></el-switch>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24"><strong style="font-size: 16px">收费方式</strong></el-col>
              </el-row>
            </el-form>
            <el-form ref="feeType3Form" id="feeType3Form" v-if="feeType3" :model="feeRule" margin-top="0">
              <el-row>
                <el-col :span="11">
                  <el-form-item label="自然天内，单次停车收费限额:" prop="dayOnceHighestAmount" :rules="moneyRules"
                                label-width="230px">
                    <el-input type="number" v-model="feeRule.dayOnceHighestAmount"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="1">
                  <el-form-item label="元" label-width="30px">
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item label="自然天内，多次停车收费限额:" prop="dayRepeatedlyHighestAmount" :rules="moneyRules"
                                label-width="230px">
                    <el-input type="number" v-model="feeRule.dayRepeatedlyHighestAmount"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="1">
                  <el-form-item label="元" label-width="30px">
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-radio v-model="feeRule.feeMethod" label="1">按停车时间收费</el-radio>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="2" offset="1">
                  <el-form-item label-width="0px" prop="useStage1">
                    <el-checkbox v-model="feeRule.useStage1" disabled="true" @change="useStage1Change">
                      阶段一:
                    </el-checkbox>
                  </el-form-item>
                </el-col>
                <el-col :span="2">
                  <el-form-item label="" prop="stage1Time1" label-width="1px" :rules="stage1TimeRules">
                    <el-input type="number" v-model="feeRule.stage1Time1" :disabled="!feeRule.useStage1"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="分钟内收费" prop="stage1Fee1" label-width="100px" :rules="stage1MoneyRules">
                    <el-input type="number" v-model="feeRule.stage1Fee1" :disabled="!feeRule.useStage1"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="元，之后每" prop="stage1Time2" label-width="100px" :rules="stage1TimeRules">
                    <el-input type="number" v-model="feeRule.stage1Time2" :disabled="!feeRule.useStage1"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="分钟，收费" prop="stage1Fee2" label-width="100px" :rules="stage1MoneyRules">
                    <el-input type="number" v-model="feeRule.stage1Fee2" :disabled="!feeRule.useStage1"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="1">
                  <el-form-item label="元" label-width="30px">
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="2" offset="1">
                  <el-form-item label-width="0px" prop="useStage2">
                    <el-checkbox v-model="feeRule.useStage2" :disabled="!feeRule.useStage1" @change="useStage2Change">阶段二:</el-checkbox>
                  </el-form-item>
                </el-col>
                <el-col :span="2">
                  <el-form-item label="" prop="stage2Time1" label-width="1px" :rules="stage2TimeRules">
                    <el-input type="number" v-model="feeRule.stage2Time1" :disabled="!feeRule.useStage2"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="分钟后，每" prop="stage2Time2" label-width="100px" :rules="stage2TimeRules">
                    <el-input type="number" v-model="feeRule.stage2Time2" :disabled="!feeRule.useStage2"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="分钟，收费" prop="stage2Fee2" label-width="100px" :rules="stage2MoneyRules">
                    <el-input type="number" v-model="feeRule.stage2Fee2" :disabled="!feeRule.useStage2"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="1">
                  <el-form-item label="元" label-width="30px">
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="2" offset="1">
                  <el-form-item label-width="0px" prop="useStage1">
                    <el-checkbox v-model="feeRule.useStage3" :disabled="!feeRule.useStage2" @change="useStage3Change">阶段三:</el-checkbox>
                  </el-form-item>
                </el-col>
                <el-col :span="2">
                  <el-form-item label="" prop="stage3Time1" label-width="1px" :rules="stage3TimeRules">
                    <el-input type="number" v-model="feeRule.stage3Time1" :disabled="!feeRule.useStage3"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="分钟后，每" prop="stage3Time2" label-width="100px" :rules="stage3TimeRules">
                    <el-input type="number" v-model="feeRule.stage3Time2" :disabled="!feeRule.useStage3"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="分钟，收费" prop="stage3Fee2" label-width="100px" :rules="stage3MoneyRules">
                    <el-input type="number" v-model="feeRule.stage3Fee2" :disabled="!feeRule.useStage3"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="1">
                  <el-form-item label="元" label-width="30px">
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="1" offset="1">
                  <el-form-item label-width="0px" prop="useStage1">
                    <el-checkbox v-model="feeRule.useStage4" :disabled="disableFeeMethod1" @change="useStage4Change"></el-checkbox>
                  </el-form-item>
                </el-col>
                <el-col :span="3">
                  <el-form-item label="" prop="stage4Time1" label-width="1px" :rules="stage4TimeRules">
                    <el-time-picker
                      style="width:100%"
                      v-model="feeRule.stage4Time1"
                      :disabled="!feeRule.useStage4"
                      value-format="HH:mm:ss"
                      :picker-options="{selectableRange: '00:00:00 - 23:59:59' }"
                      placeholder="选择时间点">
                    </el-time-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="之后，加收" prop="stage4Fee2" label-width="100px" :rules="stage4MoneyRules">
                    <el-input type="number" v-model="feeRule.stage4Fee2" :disabled="!feeRule.useStage4"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="1">
                  <el-form-item label="元" label-width="30px">
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-radio v-model="feeRule.feeMethod" label="2">按次数收费</el-radio>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="1" offset="1">
                  <el-form-item label-width="0px" prop="useTimes1">
                    <el-checkbox v-model="feeRule.useTimes1" disabled="true" @change="useTimes1Change"></el-checkbox>
                  </el-form-item>
                </el-col>
                <el-col :span="2">
                  <el-form-item label="" prop="times1Time" label-width="1px" :rules="times1TimeRules">
                    <el-input type="number" v-model="feeRule.times1Time" :disabled="!feeRule.useTimes1"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="7">
                  <el-form-item label="分钟内，每次收费" prop="times1Fee1" label-width="150px" :rules="times1MoneyRules">
                    <el-input type="number" v-model="feeRule.times1Fee1" :disabled="!feeRule.useTimes1"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="元，超过后每次收费" prop="times1Fee2" label-width="150px" :rules="times1MoneyRules">
                    <el-input type="number" v-model="feeRule.times1Fee2" :disabled="!feeRule.useTimes1"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="1">
                  <el-form-item label="元" label-width="30px">
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="1" offset="1">
                  <el-form-item label-width="0px" prop="useTimes2">
                    <el-checkbox v-model="feeRule.useTimes2" :disabled="!feeRule.useTimes1" @change="useTimes2Change"></el-checkbox>
                  </el-form-item>
                </el-col>
                <el-col :span="3">
                  <el-form-item label="" prop="times2Time" label-width="1px" :rules="times2TimeRules">
                    <el-time-picker
                      style="width:100%"
                      v-model="feeRule.times2Time"
                      :disabled="!feeRule.useTimes2"
                      value-format="HH:mm:ss"
                      :picker-options="{selectableRange: '00:00:00 - 23:59:59' }"
                      placeholder="选择时间点">
                    </el-time-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="之后，加收" prop="times2Fee2" label-width="100px" :rules="times2MoneyRules">
                    <el-input type="number" v-model="feeRule.times2Fee2" :disabled="!feeRule.useTimes2"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="1">
                  <el-form-item label="元" label-width="30px">
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <el-form ref="feeType5Form" id="feeType5Form" v-if="feeType5" :model="feeRule" label-width="90px"
                     margin-top="0">
              <el-col :span="6">
                <el-form-item label="1小时(元)" prop="parkingTime01" :rules="moneyRules">
                  <el-input type="number" v-model="feeRule.parkingTime01"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="2小时(元)" prop="parkingTime02" :rules="moneyRules">
                  <el-input type="number" v-model="feeRule.parkingTime02"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="3小时(元)" prop="parkingTime03" :rules="moneyRules">
                  <el-input type="number" v-model="feeRule.parkingTime03"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="4小时(元)" prop="parkingTime04" :rules="moneyRules">
                  <el-input type="number" v-model="feeRule.parkingTime04"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="5小时(元)" prop="parkingTime05" :rules="moneyRules">
                  <el-input type="number" v-model="feeRule.parkingTime05"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="6小时(元)" prop="parkingTime06" :rules="moneyRules">
                  <el-input type="number" v-model="feeRule.parkingTime06"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="7小时(元)" prop="parkingTime07" :rules="moneyRules">
                  <el-input type="number" v-model="feeRule.parkingTime07"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="8小时(元)" prop="parkingTime08" :rules="moneyRules">
                  <el-input type="number" v-model="feeRule.parkingTime08"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="9小时(元)" prop="parkingTime09" :rules="moneyRules">
                  <el-input type="number" v-model="feeRule.parkingTime09"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="10小时(元)" prop="parkingTime10" :rules="moneyRules">
                  <el-input type="number" v-model="feeRule.parkingTime10"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="11小时(元)" prop="parkingTime11" :rules="moneyRules">
                  <el-input type="number" v-model="feeRule.parkingTime11"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="12小时(元)" prop="parkingTime12" :rules="moneyRules">
                  <el-input type="number" v-model="feeRule.parkingTime12"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="13小时(元)" prop="parkingTime13" :rules="moneyRules">
                  <el-input type="number" v-model="feeRule.parkingTime13"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="14小时(元)" prop="parkingTime14" :rules="moneyRules">
                  <el-input type="number" v-model="feeRule.parkingTime14"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="15小时(元)" prop="parkingTime15" :rules="moneyRules">
                  <el-input type="number" v-model="feeRule.parkingTime15"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="16小时(元)" prop="parkingTime16" :rules="moneyRules">
                  <el-input type="number" v-model="feeRule.parkingTime16"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="17小时(元)" prop="parkingTime17" :rules="moneyRules">
                  <el-input type="number" v-model="feeRule.parkingTime17"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="18小时(元)" prop="parkingTime18" :rules="moneyRules">
                  <el-input type="number" v-model="feeRule.parkingTime18"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="19小时(元)" prop="parkingTime19" :rules="moneyRules">
                  <el-input type="number" v-model="feeRule.parkingTime19"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="20小时(元)" prop="parkingTime20" :rules="moneyRules">
                  <el-input type="number" v-model="feeRule.parkingTime20"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="21小时(元)" prop="parkingTime21" :rules="moneyRules">
                  <el-input type="number" v-model="feeRule.parkingTime21"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="22小时(元)" prop="parkingTime22" :rules="moneyRules">
                  <el-input type="number" v-model="feeRule.parkingTime22"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="23小时(元)" prop="parkingTime23" :rules="moneyRules">
                  <el-input type="number" v-model="feeRule.parkingTime23"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="24小时(元)" prop="parkingTime24" :rules="moneyRules">
                  <el-input type="number" v-model="feeRule.parkingTime24"></el-input>
                </el-form-item>
              </el-col>
            </el-form>
            <el-form>
              <el-col offset="9" id="button-back">
                <el-button type="primary" icon="el-icon-circle-check" @click="saveData" :disabled="buttonDisabled">保 存</el-button>
                <el-button icon="el-icon-circle-close" @click="cancelData">返回</el-button>
              </el-col>
            </el-form>
          </basic-container>
        </el-col>
        <el-col :span="1" id="feeTestLine">
          <basic-container>
            <el-divider direction="vertical"></el-divider>
          </basic-container>
        </el-col>
        <el-col :span="4">
          <basic-container>
            <el-form ref="testFeeForm" :model="testFeeForm" label-width="120px" margin-top="0">
              <el-row>
                <el-col :span="16" offset="8" style="font-size: 16px"><strong>收费测试</strong></el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="开始时间" prop="startTime" label-width="30" :rules="timeRule">
                    <el-date-picker
                      v-model="testFeeForm.startTime"
                      type="datetime"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      style="width:100%"
                      placeholder="选择开始时间">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="结束时间" prop="endTime" label-width="30" :rules="timeRule">
                    <el-date-picker
                      v-model="testFeeForm.endTime"
                      type="datetime"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      style="width:100%"
                      placeholder="选择结束时间">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24" id="stopTime">
                  <el-form-item label="停车时长" prop="stopTime" label-width="30">
                    <el-input v-model="stopTime" disabled></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24" id="shouldAmount">
                  <el-form-item label="计算金额(元)" prop="shouldAmount" label-width="30">
                    <el-input type="number" v-model="shouldAmount" disabled></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <el-row>
              <el-col offset="7" id="testButton">
                <el-button type="primary" icon="el-icon-magic-stick" @click="submitTest">测 试</el-button>
              </el-col>
            </el-row>
          </basic-container>
        </el-col>
      </el-row>
    </el-dialog>
  </basic-container>
</template>

<script>
  import { add, getDetail, getList, remove, update, syncFeeRule, test } from '@/api/v4ward/park/tempcar/cartempcarfeerule';
  import { getSpaceTree } from '@/api/v4ward/car/carparkspace';
  import { getDictionaryWithIntKey, getDictionary } from '@/api/common';
  import { mapGetters } from 'vuex';
  import { nodeTreeByParentId } from '@/api/v4ward/car/carmonth';

  export default {
    data() {
      var moneyCheck = (rule, value, callback) => {
        if ((typeof value !== 'number' && isNaN(value)) || value < 0 || value > 999999) {
          callback(new Error('有效金额[0-999999]!'));
        } else {
          var stringValue = value + '';
          var valueArray = stringValue.split('.');
          if (stringValue.startsWith('0') && !stringValue.startsWith('0.') && stringValue.length > 1) {
            callback(new Error('有效金额[0-999999]!'));
          } else if (valueArray.length === 2 && valueArray[1].length > 2) {
            callback(new Error('最多2位有效数字!'));
          } else {
            callback();
          }
          //else if((valueArray.length === 2 && valueArray[1].length>2) || )
        }
      };
      var freeTimeCheck = (rule, value, callback) => {
        if ((typeof value !== 'number' && isNaN(value)) || value < 0) {
          callback(new Error('请输入有效数字！'));
        } else {
          var stringValue = value + '';
          var valueArray = stringValue.split('.');
          if (stringValue.startsWith('0') || valueArray.length > 1) {
            callback(new Error('请输入正整数!'));
          } else {
            callback();
          }
        }
      };
      return {
        defaultProps:{
          label: 'title',
          value: 'id',
        },
        testOption:{
          labelPosition: 'left',
          labelSuffix: '：',
          labelWidth: 120,
          gutter: 0,
          menuBtn: false,
          submitBtn: false,
          submitText: '提交',
          emptyBtn: true,
          emptyText: '清空',
          menuPosition: 'center',
          column:[
            {
              labelWidth:0,
              prop: 'carParkSpaceAreaId',
              span: 24,
              hide: true,
              editDisplay: true,
              addDisplay: true,
              viewDisplay: false,
              multiple: true,
              checkStrictly: true,
              type: 'tree',
              dataType: 'string',
              dicData: [],
              props: {
                label: 'title',
                value: 'id',
              },
              rules: [
                {
                  required: true,
                  message: '请选择区域',
                  trigger: 'change',
                },
              ],
            }]
        },
        spaceAreaList:[],
        spaceAreaSelectList:[],
        spaceList: [],
        tempParkingLotId: '',
        reWrite: false,
        firstDisplayFlag: true,
        operateName: '新增',
        editDisable: false,
        showOperateDialog: false,
        buttonDisabled: false,
        //自然天
        feeType3: false,
        //单位时间收费
        feeType5: false,
        feeType1: false,
        feeType2: false,
        feeType4: false,
        disableFeeMethod1: true,
        disableFeeMethod2: true,
        vehicleTypeList: [],
        carFeeTypeList: [],
        driverTypeList: [
          { label: '业主', value: 1 },
          { label: '非业主', value: 2 },
        ],
        switchValue: { yes: 1, no: 0 },
        includeFreeTime: 1,
        form: {},
        primaryForm: {
          parkingLotId: '',
          carFeeType: '',
          driverType: '',
          vehicleType: '',
          carParkSpaceAreaId: '',
        },
        feeRule: {},
        moneyRules: [
          { required: true, message: '请输入收费金额', trigger: 'blur' },
          { validator: moneyCheck, trigger: 'blur' },
        ],
        freeTimeRules: [
          { required: true, message: '请输入免费时长', trigger: 'blur' },
          { validator: freeTimeCheck, trigger: 'blur' },
        ],
        minuteTimeRule: [
          { required: true, message: '请输入数字', trigger: 'blur' },
          { validator: freeTimeCheck, trigger: 'blur' },
        ],
        timeRule: [
          { required: true, message: '请选择时间', trigger: 'blur' },
        ],
        stage1MoneyRules: [],
        stage1TimeRules: [],
        stage2MoneyRules: [],
        stage2TimeRules: [],
        stage3MoneyRules: [],
        stage3TimeRules: [],
        stage4MoneyRules: [],
        stage4TimeRules: [],
        times1MoneyRules: [],
        times1TimeRules: [],
        times2MoneyRules: [],
        times2TimeRules: [],
        testFeeForm: {},
        stopTime: '',
        shouldAmount: '',
        query: {},
        loading: true,
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0,
        },
        selectionList: [],
        option: {
          height: 'auto',
          calcHeight: 30,
          tip: false,
          searchShow: true,
          searchMenuSpan: 6,
          border: true,
          index: true,
          addBtn: false,
          editBtn: false,
          viewBtn: false,
          selection: true,
          emptyBtn: false,
          dialogClickModal: false,
          indexLabel: '序号',
          align: 'center',
          labelWidth: 120,
          column: [
            {
              // 用于搜索使用
              label: '车场名称',
              prop: 'parkingLotIdSearch',
              type: 'select',
              display: false,
              hide: true,
              search: true,
              props: {
                label: 'title',
                value: 'id',
                disabled: 'disabled',
              },
            },
            {
              label: '车场名称',
              prop: 'parkingLotId',
              type: 'select',
              //dicUrl: 'api/v4ward/car/parkSpaceNode/treeChildrenCarParkNode?id=0',
              props: {
                label: 'title',
                value: 'id',
                disabled: 'disabled',
              },
              rules: [
                {
                  required: true,
                  message: '请选择车场',
                  trigger: 'change',
                },
              ],
            },
            {
              label: '区域名称',
              prop: 'carParkSpaceAreaName',
              rules: [{
                required: true,
                message: '请输入区域名称',
                trigger: 'change',
              }],
            },
            {
              label: '规则名称',
              prop: 'ruleName',
              rules: [{
                required: true,
                message: '请输入规则名称',
                trigger: 'change',
              }],
            },
            {
              label: '规则编号',
              prop: 'ruleCode',
              hide: true,
              rules: [{
                required: true,
                message: '请输入规则编号',
                trigger: 'change',
              }],
            },
            {
              label: '车辆类别',
              prop: 'vehicleType',
              type: 'select',
              dataType: 'number',
              value: 1,
              dicUrl: 'api/blade-system/dict/dictionary?code=vehicle_type',
              props: { label: 'dictValue', value: 'dictKey' },
              rules: [{
                required: true,
                message: '请选择车辆类别',
                trigger: 'change',
              }],
            },
            {
              label: '车主类型',
              prop: 'driverType',
              type: 'select',
              dicData: [
                { label: '业主', value: 1 },
                { label: '非业主', value: 2 },
              ],
              rules: [{
                required: true,
                message: '请选择车主类型',
                trigger: 'change',
              }],
            },
            {
              label: '收费方式',
              prop: 'carFeeType',
              type: 'select',
              dataType: 'number',
              value: 1,
              dicUrl: 'api/blade-system/dict/dictionary?code=tempcar_fee_type',
              props: { label: 'dictValue', value: 'dictKey' },
              rules: [{
                required: true,
                message: '请选择收费方式',
                trigger: 'change',
              }],
            },
            {
              label: '免费时长(分钟)',
              prop: 'freeTime',
              rules: [{
                required: true,
                message: '请输入免费时长(分钟)',
                trigger: 'change',
              }],
            },
            {
              label: '总收费限额(元)',
              prop: 'totalAmountLimit',
              hide: true,
              rules: [{
                required: true,
                message: '请输入总收费限额(元)',
                trigger: 'change',
              }],
            },
            {
              label: '是否包含免费时长 1是 0否',
              prop: 'includeFreeTime',
              hide: true,
              rules: [{
                required: true,
                message: '请输入是否包含免费时长 1是 0否',
                trigger: 'change',
              }],
            },
            {
              label: '同步状态',
              prop: 'syncStatus',
              type: 'select',
              dataType: 'number',
              dicUrl: 'api/blade-system/dict/dictionary?code=park_sync_status',
              props: { label: 'dictValue', value: 'dictKey' },
              display: false,
            },
            /*{
              label: '计费规则数据',
              prop: 'feeRule',
              rules: [{
                required: true,
                message: '请输入计费规则数据',
                trigger: 'change',
              }],
            },
            {
              label: '备注信息',
              prop: 'remark',
              rules: [{
                required: true,
                message: '请输入备注信息',
                trigger: 'change',
              }],
            },
            {
              label: '版本',
              prop: 'version',
              rules: [{
                required: true,
                message: '请输入版本',
                trigger: 'change',
              }],
            },*/
          ],
        },
        data: [],
      };
    },
    watch: {
      'feeRule.feeMethod'() {
        if (this.vdui.isNotEmpty(this.feeRule.feeMethod)) {
          this.feeMethodChange(this.feeRule.feeMethod);
        }
      },
    },
    activated() {
      let self = this;
      setTimeout(() => {
        this.$refs.crud.doLayout(); //解决表格错位
      }, 0);
    },
    computed: {
      ...mapGetters(['permission']),
      permissionList() {
        return {
          addBtn: this.vaildData(this.permission.cartempcarfeerule_add, false),
          //delBtn: this.vaildData(this.permission.cartempcarfeerule_delete, false),
          editBtn: this.vaildData(this.permission.cartempcarfeerule_edit, false),
          syncBtn: this.vaildData(this.permission.cartempcarfeerule_sync, false),
        };
      },
      ids() {
        let ids = [];
        this.selectionList.forEach(ele => {
          ids.push(ele.id);
        });
        return ids.join(',');
      },
    },
    created() {
      getSpaceTree().then((data) => {
        this.spaceList = data.data;
        if (this.spaceList.length > 0) {

          var spaceColumn = this.findObject(this.option.column, 'parkingLotId');
          spaceColumn.dicData = data.data;


          // 搜索栏使用
          var spaceSearChColumn = this.findObject(this.option.column, 'parkingLotIdSearch');
          spaceSearChColumn.dicData = data.data;

          spaceSearChColumn.searchValue = this.spaceList[0].id;
          // 默认查询第一个
          this.query.parkingLotId = this.spaceList[0].id;
          this.tempParkingLotId = this.spaceList[0].id;
          this.$nextTick(() => {
            this.reWrite = true;
          });
        } else {
          this.$nextTick(() => {
            this.reWrite = true;
          });
        }
        this.onLoad();
      });
      getDictionaryWithIntKey('vehicle_type').then((data) => {
        this.vehicleTypeList = data.data;
      });
      getDictionaryWithIntKey('tempcar_fee_type').then((data) => {
        this.carFeeTypeList = data.data;
      });
    },
    methods: {
      parkChangeEvent(val){
        nodeTreeByParentId(val).then(({ data }) => {
          this.spaceAreaList = data;
          if(data.length > 0 ){
            this.primaryForm.carParkSpaceAreaId = data[0].id;
          }else {
            this.primaryForm.carParkSpaceAreaId = "";
          }
        });
      },
      handleSync() {
        //同步。。。
        if (this.selectionList.length !== 1) {
          this.$message.warning('请选择一条数据同步下发！');
          return;
        }
        this.$confirm('确定同步下发所选临停规则?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            return syncFeeRule({ ids: this.ids });
          })
          .then(() => {
            this.onLoad();
            this.$message.success('下发成功!');
            this.$refs.crud.toggleSelection();
          });
      },
      feeMethodChange(feeMethod) {
        if(feeMethod !== '1' && feeMethod !== '2'){
          feeMethod = '1';
        }
        this.disableFeeMethod1 = feeMethod !== '1';
        this.disableFeeMethod2 = feeMethod !== '2';
        if(feeMethod === '1'){
          this.feeRule.useStage1 = true;
        }else if(feeMethod === '2'){
          this.feeRule.useTimes1 = true;
        }
        if (this.disableFeeMethod1) {
          this.feeRule.useStage1 = false;
          this.feeRule.useStage2 = false;
          this.feeRule.useStage3 = false;
          this.feeRule.useStage4 = false;
          this.useStage1Change(false);
          this.useStage2Change(false);
          this.useStage3Change(false);
          this.useStage4Change(false);
          this.useTimes1Change(true);
        }
        if (this.disableFeeMethod2) {
          this.feeRule.useTimes1 = false;
          this.feeRule.useTimes2 = false;
          this.useStage1Change(true);
          this.useTimes1Change(false);
          this.useTimes2Change(false);
        }

      },
      closeDialog() {
      },
      cancelData() {
        this.showOperateDialog = false;
      },
      saveData() {

        //公共数据校验
        this.$refs.operateForm.validate((valid) => {
          //收费信息数据校验
          var ruleCheck = this.checkFeeData();
          if (valid && ruleCheck) {
            this.buttonDisabled = true;
            this.primaryForm.includeFreeTime = this.includeFreeTime;
            add(this.primaryForm).then(() => {
              this.onLoad();
              this.$message.success('操作成功!');
              this.showOperateDialog = false;
            }, error => {
              console.log(error);
              this.buttonDisabled = false;
            });
          }
        });

      },
      submitTest() {
        this.stopTime = '';
        this.shouldAmount = '';
        this.$refs.operateForm.validate((valid) => {
          //收费信息数据校验
          var ruleCheck = this.checkFeeData();

          if (valid && ruleCheck) {
            var dateStart = Date.parse(this.testFeeForm.startTime);
            var dateEnd = Date.parse(this.testFeeForm.endTime);

            if (dateStart >= dateEnd) {
              this.$message.error('结束时间必须大于开始时间！');
              return;
            }
            this.primaryForm.includeFreeTime = this.includeFreeTime;
            this.$refs.testFeeForm.validate((valid) => {
              if(!valid){
                return;
              }
              test(Object.assign(this.testFeeForm,this.primaryForm)).then((resData) => {
                this.stopTime = resData.data.stopTime;
                this.shouldAmount = resData.data.shouldAmount;
              }, error => {
                console.log(error);
              });
            });
          }
        });
      },
      checkFeeData() {
        //单位时间收费时验证表单
        var resultCheck = false;
        if (this.feeType3) {
          this.$refs.feeType3Form.validate(valid => {
            if (valid) {
              this.primaryForm.feeRule = JSON.stringify(this.feeRule);
              resultCheck = true;
            }
          });
        }
        if (this.feeType5) {
          this.$refs.feeType5Form.validate(valid => {
            if (valid) {
              this.primaryForm.feeRule = JSON.stringify(this.feeRule);
              resultCheck = true;
            }
          });
        }
        return resultCheck;
      },
      rowSave(row, done, loading) {
        add(row).then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        }, error => {
          window.console.log(error);
          loading();
        });
      },
      rowUpdate(row, index, done, loading) {
        update(row).then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        }, error => {
          window.console.log(error);
          loading();
        });
      },
      rowDel(row) {
        this.$confirm('确定将选择数据删除?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            return remove({ ids: row.id });
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
          });
      },
      handleDelete() {
        if (this.selectionList.length === 0) {
          this.$message.warning('请选择至少一条数据');
          return;
        }
        this.$confirm('确定将选择数据删除?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            return remove({ ids: this.ids });
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
            this.$refs.crud.toggleSelection();
          });
      },
      onChangFeeType(e) {
        this.feeType3 = e === 3;
        this.feeType5 = e === 5;
        this.feeType1 = e === 1;
        this.feeType2 = e === 2;
        this.feeType4 = e === 4;
        this.feeRule = {};
        if(this.feeType3){
          if(this.feeRule.feeMethod !== '1'){
            this.stage1TimeRules = [];
            this.stage1MoneyRules = [];
            this.stage2TimeRules = [];
            this.stage2MoneyRules = [];
            this.stage3TimeRules = [];
            this.stage3MoneyRules = [];
            this.stage4TimeRules = [];
            this.stage4MoneyRules = [];
          }
          if(this.feeRule.feeMethod !== '2'){
            this.times1TimeRules = [];
            this.times1MoneyRules = [];
            this.times2TimeRules = [];
            this.times2MoneyRules = [];
          }
          if(this.feeRule.feeMethod !== '1' && this.feeRule.feeMethod !== '2'){
            this.feeRule.feeMethod = '1';
            this.feeRule.useStage1 = true;
          }
        }
      },
      copyFeeRule(row){
        this.operateName = '新增';
        this.editDisable = false;
        nodeTreeByParentId(row.parkingLotId).then((res) => {
          this.spaceAreaList = res.data;
          getDetail({id: row.id}).then(({ data }) => {
            this.primaryForm = Object.assign({},this.primaryForm,data);
            this.primaryForm.id = '';
            this.includeFreeTime = this.primaryForm.includeFreeTime;
            this.onChangFeeType(data.carFeeType);
            this.feeRule = JSON.parse(data.feeRule);
            if(this.feeRule.feeMethod !== '1' && this.feeRule.feeMethod !== '2'){
              this.feeRule.feeMethod = '1';
            }
            this.useTimes1Change(this.feeRule.useTimes1);
            this.useTimes2Change(this.feeRule.useTimes2);
            this.useStage1Change(this.feeRule.useStage1);
            this.useStage2Change(this.feeRule.useStage2);
            this.useStage3Change(this.feeRule.useStage3);
            this.useStage4Change(this.feeRule.useStage4);
            this.showOperateDialog = true;
            this.buttonDisabled = false;
          });
        });
      },
      beforeOpen(type) {
        this.cleanForm();
        this.testFeeForm = {};
        this.stopTime = '';
        this.shouldAmount = '';
        this.feeRule = {};
        if ('add' === type) {
          this.operateName = '新增';
          this.editDisable = false;
          this.primaryForm.parkingLotId = this.spaceList[0].id;
          this.primaryForm.driverType = this.driverTypeList[0].value;
          this.primaryForm.vehicleType = this.vehicleTypeList[0].dictKey;
          this.primaryForm.carFeeType = this.carFeeTypeList[0].dictKey;
          this.onChangFeeType(this.primaryForm.carFeeType);
          this.useStage1Change(this.feeRule.useStage1);
          this.showOperateDialog = true;
          this.buttonDisabled = false;
          nodeTreeByParentId(this.spaceList[0].id).then(({ data }) => {
            this.spaceAreaList = data;
            if(data.length > 0 ){
              this.primaryForm.carParkSpaceAreaId = data[0].id;
            }
          });
        } else {
          this.operateName = '编辑';
          this.editDisable = true;

          nodeTreeByParentId(type.parkingLotId).then((res) => {
            this.spaceAreaList = res.data;

            getDetail({id: type.id}).then(({ data }) => {
              this.primaryForm = Object.assign({},this.primaryForm,data);

              this.includeFreeTime = this.primaryForm.includeFreeTime;
              this.onChangFeeType(data.carFeeType);
              this.feeRule = JSON.parse(data.feeRule);
              if(this.feeRule.feeMethod !== '1' && this.feeRule.feeMethod !== '2'){
                this.feeRule.feeMethod = '1';
              }
              this.useTimes1Change(this.feeRule.useTimes1);
              this.useTimes2Change(this.feeRule.useTimes2);
              this.useStage1Change(this.feeRule.useStage1);
              this.useStage2Change(this.feeRule.useStage2);
              this.useStage3Change(this.feeRule.useStage3);
              this.useStage4Change(this.feeRule.useStage4);

              this.showOperateDialog = true;
              this.buttonDisabled = false;
            });
          });


        }
      },
      /*      beforeOpen(done, type) {
              if (['edit', 'view'].includes(type)) {
                getDetail({ id: this.primaryForm.id }).then(({ data }) => {
                  this.primaryForm = data;
                });
              } else if ('add' === type) {
                this.cleanForm();
              }
              done();
            },*/
      cleanForm() {
        for (let key in this.primaryForm) {
          this.primaryForm[key] = '';
        }
        this.feeRule = {};
        this.includeFreeTime = 1;
      },
      searchReset() {
        this.query = {};
        this.firstDisplayFlag = true;
        this.onLoad();
      },
      searchChange(params, done) {
        if(this.vdui.isEmpty(this.query.parkingLotIdSearch)){
          params.parkingLotIdSearch = this.tempParkingLotId;
        }
        this.query = params;
        this.page.currentPage = 1;
        this.onLoad();
        done();
      },
      selectionChange(list) {
        this.selectionList = list;
      },
      selectionClear() {
        this.selectionList = [];
        this.$refs.crud.toggleSelection();
      },
      currentChange(currentPage) {
        this.page.currentPage = currentPage;
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
      },
      onLoad(page) {
        page = page || this.page;
        this.loading = true;
        if (this.vdui.isEmpty(this.query.parkingLotIdSearch)) {
          this.query.parkingLotId = this.tempParkingLotId;
          this.firstDisplayFlag = true;
        } else {
          this.query.parkingLotId = this.query.parkingLotIdSearch;
        }
        getList(
          Object.assign({ current: page.currentPage, size: page.pageSize }, this.query),
        ).then(({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();

          if (this.firstDisplayFlag) {
            let ent = document.querySelector('input[placeholder="车场名称"]');
            ent.value = this.spaceList[0].title;
            this.query.parkingLotIdSearch = this.spaceList[0].id;
            this.firstDisplayFlag = false;
          }
        });
      },
      useStage1Change(value) {
        this.feeRule = Object.assign({}, this.feeRule, { useStage1: value });
        if(value){
          this.stage1TimeRules = this.minuteTimeRule;
          this.stage1MoneyRules = this.moneyRules;
        }else{
          this.feeRule.useStage2 = false;
          this.feeRule.useStage3 = false;
          this.feeRule.useStage4 = false;
          this.stage1TimeRules = [];
          this.stage1MoneyRules = [];
        }
      },
      useStage2Change(value){
        if(value){
          this.stage2TimeRules = this.minuteTimeRule;
          this.stage2MoneyRules = this.moneyRules;
        }else{
          this.feeRule.useStage3 = false;
          this.stage2TimeRules = [];
          this.stage2MoneyRules = [];
        }
      },
      useStage3Change(value){
        if(value){
          this.stage3TimeRules = this.minuteTimeRule;
          this.stage3MoneyRules = this.moneyRules;
        }else{
          this.stage3TimeRules = [];
          this.stage3MoneyRules = [];
        }
      },
      useStage4Change(value){
        if(value){
          this.stage4TimeRules = this.timeRule;
          this.stage4MoneyRules = this.moneyRules;
        }else{
          this.stage4TimeRules = [];
          this.stage4MoneyRules = [];
/*          this.$refs.feeType3Form.validate(valid =>{
            console.log(valid);
          });*/
        }
      },
      useTimes1Change(value){
        if(value){
          this.times1TimeRules = this.minuteTimeRule;
          this.times1MoneyRules = this.moneyRules;
        }else{
          this.times1TimeRules = [];
          this.times1MoneyRules = [];
        }
      },
      useTimes2Change(value){
        if(value){
          this.times2TimeRules = this.timeRule;
          this.times2MoneyRules = this.moneyRules;
        }else{
          this.times2TimeRules = [];
          this.times2MoneyRules = [];
        }
      },
    },
  };
</script>

<style>
  .el-dialog__body {
    padding: 0 20px;
  }

  #tempcar-fee-rule .el-form-item--small.el-form-item {
    margin-bottom: 12px;
  }

  #tempcar-fee-rule .el-input__inner {
    padding: 0 5px;
  }

  #button-back .el-button + .el-button {
    margin-left: 50px;
    margin-top: 20px;
  }

  #button-back .el-button--small {
    padding: 9px 20px;
  }

  #tempcar-fee-rule .el-divider--vertical {
    display: inline-block;
    width: 1px;
    height: 36em;
    margin: 0 1px;
    vertical-align: middle;
    position: relative;
  }

  #feeTestLine .el-card__body {
    padding: 1px !important;
  }
  #testButton .el-button--small {
    margin-top: 10px;
    padding: 9px 20px;
  }
  #shouldAmount input.el-input__inner {
    color: red !important;
    font-size: 16px;
    background-color: #FFF !important;
  }
  #stopTime input.el-input__inner {
    color: red !important;
    font-size: 16px;
    background-color: #FFF !important;
  }
  #areaform .el-col {
    margin-bottom: 0;
  }
  #areaform .avue-form__row {
    height: 37px;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  #areaform .el-col{
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
</style>
